export default {"src":"/_next/static/media/icon-bicycle.e5c51417.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};